module.exports = __webpack_public_path__ + "static/media/zw.f2a3677f.svg";